//Include router & store
import VueRouter from 'vue-router';
import Vue from 'vue';
window.Vue = Vue;

window.$ = window.jQuery;

if (document.getElementById('agronomist-directory')) {
	/**
	 * Promise Polyfill for Old IE
	 */
	require('es6-promise').polyfill();
	require('fetch-ie8');
	require('array-from');

	//Include components and mixins
	window.mixins = require('./vue/mixins');
	window.components = require('./vue/components');
	Vue.mixin(mixins);

	//Router
	Vue.use(VueRouter);

	const router = new VueRouter({
		mode: 'history',
		routes: require('./vue/routes')
	});

	//Init vue
	const app = new Vue({
		el: '#agronomist-directory',
		router,

		data() {
			return {}
		},
	});
}
